import { readFile, fileSave, updateVar } from '@ps/api/editor/file'
import router from '@ps/router'
import { projectBasicPath } from '@ps/workbench/config'
import { getIframe } from '@ps/bridge/iframe/iframe'
import { IframeWindow } from '@ps/bridge/iframe/iframe.window.type'
import qc from 'qc'
import { getDescendants } from '@ps/bridge/qc/node/utils'
import { Message } from 'element-ui'
import { reloadScript } from '@ps/utils/game'
import { cloneDeep } from 'lodash'
import { AssetRoute, gamePlayTemplateScripts } from '@ps/utils/config'
import assets from '@ps/bridge/qc/assets'
import { getAllParentsBeforeScene, isDragonBoneChild } from '@ps/bridge/qc/base'
import { has2dComponentParent } from '@ps/workbench/undo-redo/module/play-component'
import gameIframe from '@ps/bridge/iframe/iframe'

export async function cooperationMerge(): Promise<{ res: number }> {
  const pid = Number(router.currentRoute.query.id)
  const content: any = await readFile({
    pid,
    path: 'StartScene_tech.html',
  })
  if (content.code === 1) {
    return await { res: 0 }
  }
  const iframe = document.createElement('iframe')
  document.body.appendChild(iframe)
  iframe.style.visibility = 'hidden'
  iframe.src = `${projectBasicPath}${pid}/StartScene_tech.html`
  return new Promise((resolve, reject) => {
    window.addEventListener(
      'message',
      async (event) => {
        if (event.data === 'scene-game-ready-tech') {
          try {
            await handleScripts(
              getIframe(),
              iframe.contentWindow as IframeWindow,
            )
          } catch (e) {
            document.body.removeChild(iframe)
            resolve({ res: 0 })
            return
          }
          merge(getIframe(), iframe.contentWindow as IframeWindow)
          document.body.removeChild(iframe)
          resolve({ res: 1 })
        }
      },
      false,
    )
  })
}
// 设计侧加载技术侧新加的脚本
async function handleScripts(
  iframeDesign: IframeWindow,
  iframeTech: IframeWindow,
) {
  const pid = Number(router.currentRoute.query.id)
  for (const i in iframeTech.qici.scripts) {
    let script = iframeTech.qici.scripts[i]
    if (typeof script === 'string') {
      const index = script.indexOf('?')
      if (index > -1) {
        script = script.slice(0, index)
      }
      const s = iframeDesign.qici.scripts.find((item) => {
        if (typeof item === 'string') {
          // @ts-ignore
          return item.indexOf(script) > -1
        }
        return false
      })
      if (!s) {
        await reloadScript({
          projectKey: pid,
          src: script,
          noNeedUpdateVar: true,
        })
      }
    }
  }
  const psScripts = iframeDesign.qici.scripts.filter((item) => {
    if (typeof item === 'string') {
      if (item.indexOf('VPComponent') > -1) {
        return true
      }
      const hasGamePlayTemplateScripts = gamePlayTemplateScripts.some(
        (script) => {
          return item.indexOf(script) > -1
        },
      )
      if (hasGamePlayTemplateScripts) {
        return true
      }
    }
    return false
  })
  iframeDesign.qici.scripts = cloneDeep(iframeTech.qici.scripts)
  psScripts.forEach((item) => {
    if (item.indexOf('?') > -1) {
      item = item.slice(0, item.indexOf('?'))
    }
    const exsist = iframeDesign.qici.scripts.some((script) => {
      return script.indexOf(item) > -1
    })
    if (!exsist) {
      iframeDesign.qici.scripts.push(item)
    }
  })
  await updateVar({
    params: {
      pid,
      name: 'scripts',
    },
    data: JSON.stringify(iframeDesign.qici.scripts),
  })
}

function merge(iframeDesign: IframeWindow, iframeTech: IframeWindow) {
  const nodes2 = iframeTech.qc_game.nodePool._nodes
  const iframeTechQc = iframeTech.qc
  const ignoreScript = [
    'ps.Layout',
    'playsmart.editor.data',
    'ps.AudioNode',
    'ps.Drager',
    'ps.DragTarget',
    'ps.EditText',
    'ps.EmptyNode',
    'ps.GlobalConfigBg',
    'ps.SceneConfig',
    'ps.TweenPositionArea',
    'ps.VerticalHorizontal',
    'ps.Video',
    'ps.VideosManager',
    'ps.VPGamePlay',
    'ps.VPHand',
    'ps.VPTimer',
    'ps.GridView',
    'ps.Languages',
    'ps.MovieClip',
    'ps.SKPlayer',
    'ps.ScaleAdapterMtg',
    'ps.PEData',
    'qc.TweenPosition',
    'qc.TweenAlpha',
    'qc.TweenRotation',
    'qc.TweenScale',
    'qc.TweenColor',
    'ps.EraseComponent',
    'ps.EraseGroup',
    'ps.EraseHandImage',
    'ps.EraseLayer',
    'ps.EraseArea',
    'ps.ParkComponent',
    'ps.PuzzleComponent',
    'ps.MaskComponent',
    'ps.MaskGroup',
    'ps.ShelvesComponent',
  ]
  for (const i in nodes2) {
    const node1 = iframeDesign.qc_game.nodePool.find(i)
    const node2 = nodes2[i]
    if (node1) {
      const ped = node1.getScript('playsmart.editor.data')
      let createFromPSScripts: string[] | undefined
      if (ped) {
        createFromPSScripts = node1.getScript('playsmart.editor.data').$data
          .createFromPSScripts
      }
      // playsmart.editor.data里的box2d数据以研发侧为准
      const ped2 = node2.getScript('playsmart.editor.data')
      if (ped2 && ped2.$data.box2d && ped && ped.$data.box2d) {
        ped.$data.box2d.bodyType = ped2.$data.box2d.bodyType
      }
      // 把技术端script的持久化数据赋值给设计端
      node2.scripts.forEach((script: any) => {
        if (ignoreScript.includes(script.class)) {
          return
        }
        // 如果是ps平台添加的脚本,以ps平台的为准
        if (createFromPSScripts && createFromPSScripts.includes(script.class)) {
          return
        }
        let s = node1.getScript(script.class)
        if (typeof s === 'undefined') {
          s = node1.addScript(script.class)
        }
        s.enable = script.enable
        if (script.class === 'qc.Box2D.Body') {
          // todo 所有box2d参数覆盖
          s.type = script.type
        }
        if (script.serializableFields) {
          const keys = Object.keys(script.serializableFields)
          keys.forEach((key) => {
            if (
              script.serializableFields[key] === iframeTech.qc.Serializer.NODES
            ) {
              if (script[key]) {
                s[key] = script[key].map((item: qc.Node) => {
                  if (item) {
                    return iframeDesign.qc_game.nodePool.find(item.uuid)
                  }
                  return null
                })
              }
            } else if (
              script.serializableFields[key] ===
                iframeTech.qc.Serializer.NODE ||
              (script.serializableFields[key] ===
                iframeTech.qc.Serializer.AUTO &&
                script[key] instanceof iframeTechQc.Node)
            ) {
              if (script[key]) {
                s[key] = iframeDesign.qc_game.nodePool.find(script[key].uuid)
              } else {
                s[key] = null
              }
            } else if (
              script.serializableFields[key] ===
                iframeTech.qc.Serializer.TEXTURE ||
              (script.serializableFields[key] ===
                iframeTech.qc.Serializer.AUTO &&
                script[key] instanceof iframeTechQc.Texture)
            ) {
              if (script[key]) {
                const asset = iframeDesign.qc_game.assets.findByUUID(
                  script[key].atlas.uuid,
                )
                const Texture = iframeDesign.qc.Texture
                s[key] = new Texture(asset, 0)
              } else {
                s[key] = null
              }
            } else if (
              script.serializableFields[key] ===
              iframeTech.qc.Serializer.TEXTURES
            ) {
              if (script[key]) {
                if (!s[key]) {
                  s[key] = []
                }
                for (const i in script[key]) {
                  const item = script[key][i]
                  if (item) {
                    const asset = iframeDesign.qc_game.assets.findByUUID(
                      item.atlas.uuid,
                    )
                    const Texture = iframeDesign.qc.Texture
                    s[key][i] = new Texture(asset, 0)
                  } else {
                    s[key][i] = null
                  }
                }
              }
            } else if (
              script.serializableFields[key] ===
                iframeTech.qc.Serializer.PREFAB ||
              (script.serializableFields[key] ===
                iframeTech.qc.Serializer.AUTO &&
                script[key] instanceof iframeTechQc.Prefab)
            ) {
              if (script[key]) {
                s[key] = new iframeDesign.qc.Prefab(
                  script[key].key,
                  script[key].url,
                  script[key].json,
                  script[key].meta,
                )
              } else {
                s[key] = null
              }
            } else if (
              script.serializableFields[key] ===
              iframeTech.qc.Serializer.PREFABS
            ) {
              if (script[key]) {
                if (!s[key]) {
                  s[key] = []
                }
                for (const i in script[key]) {
                  const item = script[key][i]
                  if (item) {
                    s[key][i] = new iframeDesign.qc.Prefab(
                      item.key,
                      item.url,
                      item.json,
                      item.meta,
                    )
                  } else {
                    s[key][i] = null
                  }
                }
              }
            } else if (
              script.serializableFields[key] ===
                iframeTech.qc.Serializer.COLOR ||
              (script.serializableFields[key] ===
                iframeTech.qc.Serializer.AUTO &&
                script[key] instanceof iframeTechQc.Color)
            ) {
              if (script[key]) {
                const { r, g, b } = script[key]
                const cc = `rgba(${r}, ${g}, ${b})`
                s[key] = new iframeDesign.qc.Color(cc)
              } else {
                s[key] = null
              }
            } else {
              s[key] = script[key]
            }
          })
        }
      })
      node1.banPSRemove = node2.banPSRemove
      // 删除node1比node2多出来的script
      const deleteScript: any = []
      node1.scripts.forEach((script: any) => {
        if (ignoreScript.includes(script.class)) {
          return
        }
        // 如果是ps平台添加的脚本,以ps平台的为准
        if (createFromPSScripts && createFromPSScripts.includes(script.class)) {
          return
        }
        const s = node2.getScript(script.class)
        if (!s) {
          deleteScript.push(script.class)
        }
      })
      deleteScript.forEach((script: any) => {
        const s = node1.getScript(script)
        node1.removeScript(s)
      })
    }
  }
}

export async function cooperationUpdateVersion() {
  const pid = Number(router.currentRoute.query.id)
  const content: any = await readFile({
    pid,
    path: 'info.json',
  })
  let info
  if (content.code === 1) {
    info = { version: 0 }
  } else {
    info = content
  }
  const version = Number(info.version)
  info.version = version + 1
  await fileSave({
    projectKey: pid,
    path: 'info.json',
    binContent: JSON.stringify(info),
  })
}

/**
 * 协同流程中,需要判断该节点是否是研发声明禁止删除的
 * @param node 节点
 * @returns boolean
 */
export function hasBanRemoveNode(node: qc.Node): boolean {
  const descendantsNode = getDescendants(node)
  for (const i in descendantsNode) {
    const _node: qc.Node | undefined = descendantsNode[i]
    if (_node && _node.banPSRemove) {
      Message({
        message: `当前节点或子节点${_node.name}为研发同学声明禁止删除的节点`,
        type: 'error',
      })
      return true
    }
  }
  return false
}
let uuid2Res = {}
// 合并前先检测是否有图片和粒子节点丢失贴图资源
export function checkNodeRes() {
  const iframeDesign = getIframe()
  const nodes = iframeDesign.qc_game.nodePool._nodes
  let res = true
  const issueNodes: string[] = []
  uuid2Res = {}
  for (const i in nodes) {
    const node = nodes[i]
    if (!getAllParentsBeforeScene(node)) {
      // 祖先节点是null时
      // eslint-disable-next-line no-continue
      continue
    }
    // eslint-disable-next-line no-continue
    if (has2dComponentParent(node) || isDragonBoneChild(node)) continue // 玩法组件里的子节点或龙骨子节点暂不用检测
    if (node.class === 'qc.UIImage' || node.maxParticles) {
      if (node.texture) {
        uuid2Res[node.uuid] = node.texture.atlas.url
      } else {
        res = false
        issueNodes.push(node.name)
      }
    }
  }
  if (res) {
    return {
      res: true,
      nodeUuid2Res: uuid2Res,
      tip: null,
    }
  }
  const tip = issueNodes.toString()
  return {
    res: false,
    nodeUuid2Res: uuid2Res,
    errTip: `合并前检测：${tip}丢失贴图资源`,
  }
}
// 合并后还原图片和粒子节点丢失的贴图资源
export async function recoverNodeRes() {
  const iframeDesign = getIframe()
  const nodes = iframeDesign.qc_game.nodePool._nodes
  for (const i in nodes) {
    const node = nodes[i]
    if (!getAllParentsBeforeScene(node)) {
      // 祖先节点是null时
      // eslint-disable-next-line no-continue
      continue
    }
    // eslint-disable-next-line no-continue
    if (has2dComponentParent(node) || isDragonBoneChild(node)) continue // 玩法组件里的子节点或龙骨子节点暂不用检测
    if (node.class === 'qc.UIImage' || node.maxParticles) {
      if (!node.texture) {
        const asset = await assets.load({
          url: uuid2Res[node.uuid],
          override: true,
        })
        const Texture = iframeDesign.qc.Texture
        node.texture = new Texture(asset, 0)
      }
    }
  }
}
// 检测是否有丢失资源，有则补回
export async function fixMissNodeRes() {
  const iframeDesign = getIframe()
  const nodes = iframeDesign.qc_game.nodePool._nodes
  let nodeUuid2Res = null
  for (const i in nodes) {
    const node = nodes[i]
    if (!getAllParentsBeforeScene(node)) {
      // 祖先节点是null时
      // eslint-disable-next-line no-continue
      continue
    }
    // eslint-disable-next-line no-continue
    if (has2dComponentParent(node) || isDragonBoneChild(node)) continue // 玩法组件里的子节点或龙骨子节点暂不用检测
    if (node.class === 'qc.UIImage' || node.maxParticles) {
      if (!node.texture) {
        if (!nodeUuid2Res) {
          const pid = Number(router.currentRoute.query.id)
          nodeUuid2Res = await readFile({
            pid,
            path: AssetRoute.NODE_UUID2RES,
          })
          if (nodeUuid2Res.code === 1) {
            nodeUuid2Res = null
          }
        }
        // 用上一次保存时的配置记录补回资源
        if (
          nodeUuid2Res &&
          nodeUuid2Res[node.uuid] &&
          nodeUuid2Res[node.uuid] !== '__builtin_resource__'
        ) {
          const asset = await assets.load({
            url: nodeUuid2Res[node.uuid],
            override: true,
          })
          const Texture = iframeDesign.qc.Texture
          node.texture = new Texture(asset, 0)
        } else {
          // 没有记录则用空贴图兜底
          const res = gameIframe.qcGame.assets.find('__builtin_resource__')
          const emptyTexture = res.getTexture('empty.png')
          node.texture = emptyTexture
        }
      }
    }
  }
}
